import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M16 0v16H.003v-.017c-.033-2.492.2-5.316.863-8.108 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M4.288 2.402 8 6.114 14.065.05A56.78 56.78 0 0 1 16 0v1.886L9.886 8 16 14.114V16h-1.886L8 9.886 1.886 16H.003v-.017c-.008-.614 0-1.249.027-1.898L6.114 8 2.467 4.353a9.023 9.023 0 0 1 1.821-1.95Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M14.555.031C15.035.015 15.518.004 16 0L8.472 7.529l-.708-.708 6.791-6.79ZM3.308 3.307l4.22 4.222-.706.707-4.157-4.157c.194-.26.408-.52.643-.772ZM.003 16v-.003L7.53 8.47l.707.708L1.414 16H.004Zm8.469-7.529.707-.707L16 14.586V16L8.472 8.471Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M10 .399V16H6V1.372c.112-.05.226-.097.342-.143C7.272.876 8.544.6 10 .4Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M1.529 6H16v4H.442a30.35 30.35 0 0 1 .424-2.125s.169-.803.663-1.875Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M9.334.498V16H6.667V1.114C7.403.867 8.312.662 9.334.498Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M1.246 6.667H16v2.666H.558c.09-.485.193-.972.308-1.458 0 0 .102-.487.38-1.208Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M18.666 10h10.667v10c0 2-3.356 4.002-5.333 4-1.978-.002-5.334-2-5.334-4V10Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1FCE6D",
      fillRule: "evenodd",
      d: "M29.333 20c0 2-3.356 4.002-5.333 4-1.978-.002-5.334-2-5.334-4 0 0 2.427-.67 5.334-.667 2.906.003 5.333.667 5.333.667Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M20.51 13.745a.475.475 0 0 1 .327-.036l.678.17a.5.5 0 0 0 .606-.364l.434-1.735a1 1 0 0 1 .523-.652l.475-.238a1 1 0 0 1 .894 0l.475.238a1 1 0 0 1 .523.652l.434 1.735a.5.5 0 0 0 .606.364l.678-.17a.476.476 0 0 1 .495.747L26 16.666h1.61a.5.5 0 0 1 .485.38l.308 1.233a.5.5 0 0 1-.708.568L26 18v2.264a.5.5 0 0 0 .393.489l.62.135a.5.5 0 0 1 .33.73l-.159.29a.5.5 0 0 1-.555.244l-.454-.11a.5.5 0 0 1-.283-.186L25 20.666h-2l-.892 1.19a.5.5 0 0 1-.282.186l-.454.11a.5.5 0 0 1-.556-.245l-.16-.29a.5.5 0 0 1 .332-.73l.619-.134a.5.5 0 0 0 .393-.489V18l-1.694.847a.5.5 0 0 1-.709-.568l.308-1.234a.5.5 0 0 1 .486-.378H22l-1.66-2.211a.475.475 0 0 1 .169-.71Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#C2E7FF",
      fillRule: "evenodd",
      d: "M24.185 21.877a.333.333 0 0 1-.37 0l-1.731-1.154a.333.333 0 0 0-.185-.056h-.326a.333.333 0 0 1-.316-.228l-.555-1.667a.334.334 0 0 1 0-.21l.54-1.621a.333.333 0 0 0-.167-.404l-.816-.408a.333.333 0 0 1-.168-.403l.427-1.279a.291.291 0 0 1 .482-.114l.178.178a.333.333 0 0 0 .36.074l1.367-.547a.334.334 0 0 1 .195-.016l.829.18a.34.34 0 0 0 .142 0l.83-.18a.334.334 0 0 1 .194.016l1.367.547c.124.05.266.02.36-.074l.178-.178a.29.29 0 0 1 .482.114l.427 1.279a.333.333 0 0 1-.168.403l-.816.408a.333.333 0 0 0-.167.404l.54 1.62a.334.334 0 0 1 0 .211l-.555 1.667a.333.333 0 0 1-.317.228h-.325c-.066 0-.13.02-.185.056l-1.731 1.154Z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagBmu = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagBmu_default = SvgFlagBmu;

export { FlagBmu_default as default };
